<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container">
      <div class="cf-header">Custom Field</div>
      <div class="cf-main-container mt-2">
        <div class="d-flex flex-wrap">
          <div
            v-for="form in formsData"
            :key="form._id"
            class="cf-card mr-4 mb-4"
          >
            <div>
              <div class="d-flex align-items-center">
                <div>
                  <img :src="form.image" alt="" />
                </div>
                <div class="cf-card-head ml-3">
                  {{ form.subHeading ? form.subHeading : form.title }}
                </div>
              </div>
              <div class="cf-light-txt text-center mt-3">
                {{ form.description }}
              </div>
            </div>
            <div class="border-top pt-1">
              <div @click="gotoCustomTable(form)" class="cf-card-buttons">
                Customize
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getForms } from "../../utils/apiFunctions";
import Spinner from "../../components/fixedcomponents/Spinner.vue";

export default {
  name: "customform",
  data() {
    return {
      LoaderStatus: false,
      formsData: [],
    };
  },
  components: {
    Spinner,
  },
  methods: {
    gotoCustomTable(form) {
      this.$router.push({
        path: "customtable",
        query: {
          id: form.formID,
          heading: form.subHeading || form.title,
        },
      });
    },
    async getAllForms() {
      this.LoaderStatus = true;
      try {
        const res = await getForms();
        if (res.status == 200) {
          this.formsData = res.data.data;
          this.LoaderStatus = false;
        } else {
          this.LoaderStatus = false;
        }
      } catch (error) {
        console.error(error);
        this.LoaderStatus = false;
      }
    },
  },
  created() {
    this.getAllForms();
  },
};
</script>

<style lang="postcss" scoped></style>
